module.exports = __webpack_public_path__ + "static/media/download.f9297129.svg";